export default __webpack_public_path__ + "static/media/02.c24ffec2.webp";